import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import icSuccess from 'assets/img/ic_success.png';
import icFailed from 'assets/svg/ic_failed.svg';
export let AlertType;

(function (AlertType) {
  AlertType["SUCCESS"] = "success";
  AlertType["FAILED"] = "failed";
  AlertType["CUSTOM"] = "custom";
})(AlertType || (AlertType = {}));

const Alert = /*#__PURE__*/React.forwardRef(({
  className
}, ref) => {
  const [config, setConfig] = React.useState();
  const [isVisible, setVisible] = React.useState(false);
  const timeoutRef = React.useRef();
  const icon = React.useMemo(() => {
    switch (config === null || config === void 0 ? void 0 : config.type) {
      case AlertType.SUCCESS:
        return icSuccess;

      case AlertType.FAILED:
        return icFailed;

      default:
        return config === null || config === void 0 ? void 0 : config.icon;
    }
  }, [config]);
  React.useImperativeHandle(ref, () => {
    return {
      show: config => {
        setConfig(config);
        setVisible(true);
        timeoutRef.current && clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
          setVisible(false);
        }, 2000);
      }
    };
  });

  if (!isVisible) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container, className)
  }, /*#__PURE__*/React.createElement("img", {
    draggable: false,
    src: icon,
    className: styles.icSuccess
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, config === null || config === void 0 ? void 0 : config.title));
});
Alert.displayName = 'Alert';
export default Alert;